export default __webpack_public_path__ + "static/media/qa-liked-icon.75adfb11.svg";